
import Vue from 'vue'

interface IData {
  title: string
  description: string
}

export default Vue.extend({
  layout(ctx: any) {
    return ctx.App.state.layout || 'default'
  },
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  data(): IData {
    return {
      title: '',
      description: ''
    }
  },
  head() {
    const title = this.error.statusCode + 'エラー'
    return {
      title,
      titleTemplate: '%s - ' + process.env.APPLICATION_NAME
    }
  },
  computed: {
    mode() {
      return process.env.NODE_ENV
    },
    detail() {
      return JSON.stringify(this.error, null, 2)
    }
  },
  watch: {
    error: {
      handler(error: any) {
        if (!error.statusCode || (error.statusCode >= 500 && error.statusCode <= 599)) {
          this.title = 'システムエラーが発生しています。'
          this.description =
            'ご不便をおかけして申し訳ございません。<br />しばらく時間をおいてから、再度アクセスいただきますようお願い申し上げます。'
        } else if (error.statusCode === 404 || error.statusCode === 403) {
          this.title = 'お探しのページは見つかりません'
          this.description = '指定されたページが見つかりません。<br>下にあるリンクから再度アクセスしてください。'
        }
      },
      immediate: true
    }
  }
})
